import { render, staticRenderFns } from "./ShiftVerificationForm.vue?vue&type=template&id=88ba9276&scoped=true&"
import script from "./ShiftVerificationForm.vue?vue&type=script&lang=js&"
export * from "./ShiftVerificationForm.vue?vue&type=script&lang=js&"
import style0 from "./ShiftVerificationForm.vue?vue&type=style&index=0&id=88ba9276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ba9276",
  null
  
)

export default component.exports